export default __webpack_public_path__ + "static/courtring-47bc51050a51f1644f5b10a9d3b40903.png";